export function getCurTreeIndex(context) {
  return context.$router.currentRoute.name || "Welcome"
}

export const isString = function (arg) {
  return typeof (arg) === 'string';
}
export const isObject = function (arg) {
  return typeof (arg) === 'object' && arg !== null;
}
export const isNull = function (arg) {
  return arg === null;
}
export const isNullOrUndefined = function (arg) {
  return arg == null;
}

export function isNotNullObj(obj) {
  return !(obj === undefined || typeof obj === 'undefined' || obj == null)
}

export function isEmpty(str) {
  return !isNotNullObj(str) ||
    str === '' ||
    /^\s+$/gi.test(str);
}

export function isNotEmpty(str) {
  return !(isEmpty(str))
}

/**
 * 根据日期
 * @param dateStr  yyyy-mm-dd / yyyy/mm/dd
 * @returns {Date}
 */
export function getDate(dateStr) {
  let arr = dateStr.split(/[/|-]/g)

  let date = new Date()
  date.setFullYear(arr[0])
  date.setMonth(arr[1] - 1)
  date.setDate(arr[2])

  return date
}

/**
 * 根据秒转成合适的格式
 * @param seconds 秒
 * @returns {string}
 */
export function formatSeconds(seconds) {
  let result = parseInt(seconds)
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
  result = `${h}:${m}:${s}`
  return result
}

/**
 * 根据秒转成合适的格式
 * @param timeStr 秒
 * @returns {number}
 */
export function getSeconds(timeStr) {
  let arr = timeStr.split(":");
  let res = parseInt(arr[0]) * 3600;
  res += parseInt(arr[1]) * 60;
  return res + parseInt(arr[2]);
}

/**
 * @param {Date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatDate(time, fmt) {
  if (!time) return ''
  else {
    const date = new Date(time)
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }

    return fmt
  }
}

export function fullTime(time) {
  return formatDate(time, "yyyy-MM-dd HH:mm:ss")
}

export function getUtcDate(targetMis) {
  // let targetMis = 1668305603000
  let localDate = new Date(targetMis);
  let utcMis = targetMis + (localDate.getTimezoneOffset() * 60000);
  let utcDate = new Date(utcMis);

  console.log('传入的时间戳：' + targetMis);
  console.log('当前时区时间：' + localDate.toLocaleString());
  console.log('UTC时区时间：' + utcDate.toLocaleString());
  return utcDate
}

export function formatVueUrl(uri) {
  if (isNotEmpty(uri)) {
    uri = uri.replace(/^\//g, '')
    if (uri.indexOf('/') === -1) {
      uri = uri.substring(0, 1).toUpperCase() + uri.substring(1);
    } else {
      uri = uri.replace(/(\/\w)(\w+\/*$)/g, function ($0, $1, $2) {
        return $1.toUpperCase() + $2
      })
    }
  }
  return uri
}

export function copyVal(form, source) {
  console.log('*************************Form赋值*************************')
  for (let p in form) {
    let v = source[p]
    if (isNotNullObj(v) && isNotEmpty(v)) {
      form[p] = v
    }
    console.log(p + ' : {' + decodeURI(v) + '} -> {' + decodeURI(form[p]) + '}')
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js